import { GraphQLObjectType } from 'graphql';

import CourseType from './course.gql';
import CoursePrerequisiteUnlockCriteriaEnumType from './enums/coursePrerequisiteUnlockCriteriaEnum.gql';

const coursePrerequisiteType = new GraphQLObjectType({
  name: 'CoursePrerequisite',
  fields: () => ({
    course: {
      type: CourseType
    },
    unlockCriteria: {
      type: CoursePrerequisiteUnlockCriteriaEnumType
    }
  })
});

window[coursePrerequisiteType.name + 'GQLType'] = coursePrerequisiteType;

export default coursePrerequisiteType;
